(function () {
  'use strict';
  let cartInitTimeout = null;
  let isCartInitializing = false;

  function safeInitializeCartOffers(itemCount = null) {
    if (isCartInitializing) return;

    clearTimeout(cartInitTimeout);

    cartInitTimeout = setTimeout(() => {
      isCartInitializing = true;

      initializeCartOffersAfterUpdate(itemCount).finally(() => {
        setTimeout(() => {
          isCartInitializing = false;
        }, 300);
      });
    }, 300);
  }

  // Expose to window for AJAX cart updates
  window.safeInitializeCartOffers = safeInitializeCartOffers;

  function initCartOffers() {
    setupPopupHandlersOnce();
    setupCouponSyncOnce();
    setupApplyHandlersOnce();
    setupRemoveCouponHandlerOnce();
    checkOfferEligibility();
  }

  let _cartOffersPopupOriginalParent = null;
  let _cartOffersPopupOriginalNext = null;

  function setupPopupHandlersOnce() {
    const viewBtn = document.getElementById('cart-view-all-offers');
    const popup = document.getElementById('cart-offers-popup');
    const closeBtn = popup?.querySelector('.cart-offers-popup__close');
    const overlay = popup?.querySelector('.cart-offers-popup__overlay');

    if (viewBtn && !viewBtn.dataset.bound) {
      viewBtn.dataset.bound = 'true';
      // If the delegated view handler is present we don't attach per-element listeners
      if (!document.body.dataset.cartViewDelegation) {
        viewBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          dedupeOffersElements();
          openOffersPopup();
        });
      }
    }

    if (closeBtn && !closeBtn.dataset.bound) {
      closeBtn.dataset.bound = 'true';
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeOffersPopup();
      });
    }

    if (overlay && !overlay.dataset.bound) {
      overlay.dataset.bound = 'true';
      overlay.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeOffersPopup();
      });
    }

    if (popup && !popup.dataset.submitBound) {
      popup.dataset.submitBound = 'true';
      popup.addEventListener('submit', (e) => {
        e.preventDefault();
      });
    }

    if (!document.body.dataset.escapeBound) {
      document.body.dataset.escapeBound = 'true';
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup?.getAttribute('aria-hidden') === 'false') {
          closeOffersPopup();
        }
      });
    }
  }

  // Delegated click handler for any "View All Offers" link. Runs once.
  if (!document.body.dataset.cartViewDelegation) {
    document.body.dataset.cartViewDelegation = 'true';
    document.body.addEventListener('click', (e) => {
      const v = e.target.closest('#cart-view-all-offers, .cart-view-all-offers');
      if (!v) return;

      if (e.target.closest('#cart-offers-popup')) return;

      e.preventDefault();
      e.stopPropagation();

      try {
        dedupeOffersElements();
      } catch (err) {
        console.error('Dedupe error:', err);
      }

      const popup = document.getElementById('cart-offers-popup') || document.querySelector('.cart-offers-popup');
      if (popup) {
        openOffersPopup();
        return;
      }

      console.warn('Popup not found, reinitializing...');
      try {
        safeInitializeCartOffers();
      } catch (err) {
        console.error('Reinit error:', err);
      }

      setTimeout(() => {
        const p2 = document.getElementById('cart-offers-popup') || document.querySelector('.cart-offers-popup');
        if (p2) {
          openOffersPopup();
        } else {
          console.error('Popup still not found after reinit');
        }
      }, 200);
    });
  }

  function openOffersPopup() {
    const popup = document.getElementById('cart-offers-popup');
    if (!popup) {
      console.error('Cannot open popup - element not found');
      return;
    }

    console.log('Opening offers popup');

    if (popup.parentNode !== document.body) {
      try {
        _cartOffersPopupOriginalParent = popup.parentNode;
        _cartOffersPopupOriginalNext = popup.nextSibling;
      } catch (e) {
        console.error('Error storing popup parent:', e);
      }
      document.body.appendChild(popup);
    }

    popup.removeAttribute('inert');
    popup.style.pointerEvents = 'auto';
    popup.style.userSelect = 'auto';
    popup.style.display = 'flex';
    popup.style.visibility = 'visible';
    popup.style.opacity = '1';

    popup.querySelectorAll('*').forEach(el => {
      el.removeAttribute('inert');
      el.style.pointerEvents = 'auto';
    });

    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
      const input = document.getElementById('cart-offers-coupon-input');
      if (input) {
        input.disabled = false;
        input.readOnly = false;
        input.tabIndex = 0;
        try {
          input.focus();
        } catch (e) {
          console.error('Focus error:', e);
        }
      }
    }, 100);
  }

  function closeOffersPopup() {
    const popup = document.getElementById('cart-offers-popup');
    if (!popup) return;

    console.log('Closing offers popup');

    popup.removeAttribute('inert');
    popup.style.pointerEvents = '';
    popup.style.userSelect = '';
    popup.style.display = '';
    popup.style.visibility = '';
    popup.style.opacity = '';

    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    if (_cartOffersPopupOriginalParent) {
      try {
        if (_cartOffersPopupOriginalNext && _cartOffersPopupOriginalNext.parentNode === _cartOffersPopupOriginalParent) {
          _cartOffersPopupOriginalParent.insertBefore(popup, _cartOffersPopupOriginalNext);
        } else {
          _cartOffersPopupOriginalParent.appendChild(popup);
        }
      } catch (e) {
        console.error('Error restoring popup:', e);
      }
      _cartOffersPopupOriginalParent = null;
      _cartOffersPopupOriginalNext = null;
    }

    dedupeOffersElements();
  }

  function dedupeOffersElements() {
    try {
      const viewBtns = Array.from(document.querySelectorAll('#cart-view-all-offers'));
      if (viewBtns.length > 1) {
        console.log('Removing duplicate view buttons:', viewBtns.length - 1);
        viewBtns.slice(1).forEach((el) => el.remove());
      }

      const popups = Array.from(document.querySelectorAll('#cart-offers-popup'));
      if (popups.length > 1) {
        console.log('Removing duplicate popups:', popups.length - 1);
        const bodyPopup = popups.find(p => p.parentNode === document.body) || popups[0];
        popups.forEach(p => {
          if (p !== bodyPopup) p.remove();
        });
      }
    } catch (e) {
      console.error('Dedupe error:', e);
    }
  }

  /*********************************
   * COUPON INPUT SYNC (ONCE)
   *********************************/
  function setupCouponSyncOnce() {
    const input = document.getElementById('cart-coupon-input');
    const popupInput = document.getElementById('cart-offers-coupon-input');
    const btn = document.getElementById('cart-coupon-apply-btn');
    const popupBtn = document.getElementById('cart-offers-popup-apply-btn');

    if (input && popupInput) {
      if (input.dataset.synced) return;
      input.dataset.synced = 'true';

      input.addEventListener('input', () => {
        popupInput.value = input.value;
        toggleApplyButton(input, btn);
        toggleApplyButton(popupInput, popupBtn);
      });

      popupInput.addEventListener('input', () => {
        input.value = popupInput.value;
        toggleApplyButton(input, btn);
        toggleApplyButton(popupInput, popupBtn);
      });
    }
  }

  // Delegated input sync
  if (!document.body.dataset.cartCouponDelegation) {
    document.body.dataset.cartCouponDelegation = 'true';
    document.body.addEventListener('input', (e) => {
      const t = e.target;
      if (!t) return;

      const isCouponInput = t.id === 'cart-coupon-input' ||
        t.id === 'cart-offers-coupon-input' ||
        t.closest('.cart-coupon-input-wrapper') ||
        t.closest('.cart-offers-popup__coupon-input-wrapper');

      if (!isCouponInput) return;

      const mainInput = document.getElementById('cart-coupon-input');
      const popupInput = document.getElementById('cart-offers-coupon-input');
      const val = t.value;

      try {
        if (mainInput && popupInput) {
          if (t === mainInput && popupInput.value !== val) popupInput.value = val;
          if (t === popupInput && mainInput.value !== val) mainInput.value = val;
        } else if (mainInput && t !== mainInput) {
          mainInput.value = val;
        } else if (popupInput && t !== popupInput) {
          popupInput.value = val;
        }
      } catch (err) {
        console.error('Input sync error:', err);
      }

      const btn = document.getElementById('cart-coupon-apply-btn');
      const popupBtn = document.getElementById('cart-offers-popup-apply-btn');
      if (btn) toggleApplyButton(mainInput || popupInput || t, btn);
      if (popupBtn) toggleApplyButton(popupInput || mainInput || t, popupBtn);
    });
  }

  // Delegated click handler for Apply buttons (resilient to DOM replacement)
  if (!document.body.dataset.cartApplyDelegation) {
    document.body.dataset.cartApplyDelegation = 'true';
    document.body.addEventListener('click', (e) => {
      const target = e.target.closest('#cart-coupon-apply-btn, #cart-offers-popup-apply-btn, .cart-coupon-apply-btn, .cart-offers-popup__coupon-apply-btn');
      if (!target) return;

      e.preventDefault();
      e.stopPropagation();

      // Prefer input inside same wrapper
      let wrapper = target.closest('.cart-coupon-input-wrapper') || target.closest('.cart-offers-popup__coupon-input-wrapper');
      let input = wrapper ? wrapper.querySelector('input[type="text"], input') : null;
      if (!input) {
        input = document.getElementById('cart-coupon-input') || document.getElementById('cart-offers-coupon-input');
      }

      if (input && input.value && input.value.trim()) {
        try {
          applyCouponCode(input.value.trim(), input, target);
        } catch (err) { console.error('Delegated apply error:', err); }
      }
    });
  }

  function setupApplyHandlersOnce() {
    bindApplyOnce('cart-coupon-input', 'cart-coupon-apply-btn');
    bindApplyOnce('cart-offers-coupon-input', 'cart-offers-popup-apply-btn');
  }

  function bindApplyOnce(inputId, btnId) {
    const input = document.getElementById(inputId);
    const btn = document.getElementById(btnId);

    if (!input || !btn) {
      console.warn(`Missing elements for ${inputId} / ${btnId}`);
      return;
    }

    if (input.dataset.bound) return;

    input.dataset.bound = 'true';
    btn.dataset.bound = 'true';

    toggleApplyButton(input, btn);

    input.addEventListener('input', () => {
      toggleApplyButton(input, btn);
    });

    input.addEventListener('keypress', (e) => {
      if (e.key === 'Enter' && input.value.trim()) {
        e.preventDefault();
        console.log('Applying coupon via Enter:', input.value.trim());
        applyCouponCode(input.value.trim(), input, btn);
      }
    });

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (input.value.trim()) {
        console.log('Applying coupon via button:', input.value.trim());
        applyCouponCode(input.value.trim(), input, btn);
      }
    });
  }

  function toggleApplyButton(input, btn) {
    if (!input || !btn) return;
    btn.style.display = input.value.trim() ? 'block' : 'none';
  }

  let _showAppliedCouponUIRunning = false;

  async function showAppliedCouponUI(code, opts = {}) {
    if (_showAppliedCouponUIRunning && !opts.force) {
      return;
    }

    _showAppliedCouponUIRunning = true;

    try {
      const wrapper = document.getElementById('cart-applied-coupon');
      const codeEl = document.getElementById('applied-coupon-code');
      const savedEl = document.getElementById('applied-coupon-saved');
      const inputWrapper = document.querySelector('.cart-coupon-input-wrapper');
      const greenTick = document.querySelector('.cart-offers-popup__coupon-success');
      const updateDiscountList = document.querySelector('.cart-offers-popup__body #cart-applied-coupon');
      const upadateDiscountCode = document.querySelector('.cart-offers-popup__body #applied-coupon-code');
      const discountCodeInput = document.querySelector('.cart-offers-popup__body #cart-offers-coupon-input');

      if (!wrapper || !codeEl || !savedEl) {
        _showAppliedCouponUIRunning = false;
        return;
      }

      codeEl.textContent = code;
      codeEl.className = 'cart-applied-coupon__code';

      const forceShow = Boolean(opts && opts.force);

      if (forceShow) {
        if (inputWrapper) inputWrapper.style.display = 'none';
        savedEl.textContent = 'Saved...';
        wrapper.style.display = 'flex';

        if (updateDiscountList) {
          updateDiscountList.style.display = 'flex';
        }

        if (upadateDiscountCode) {
          upadateDiscountCode.textContent = code;
        }

        if (greenTick) {
          greenTick.style.display = 'none';
        }

        if (discountCodeInput) {
          discountCodeInput.value = '';
        }

        (async () => {
          try {
            const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
            if (!cartRes || !cartRes.ok) throw new Error('no-cart');
            const cart = await cartRes.json();
            let discountPresent = false;
            if (code) {
              if (Array.isArray(cart.discount_codes) && cart.discount_codes.some(dc => ((dc.code || String(dc) || '')).toUpperCase() === code.toUpperCase() && dc.applicable !== false)) {
                discountPresent = true;
              }
              if (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.some(a => (a.title || a.code || a.discount_code || '').toString().toUpperCase() === code.toUpperCase())) {
                discountPresent = true;
              }
            }

            if (!discountPresent) {
              try { localStorage.removeItem('applied_coupon_code'); } catch (e) { }
              if (wrapper) wrapper.style.display = 'none';
              if (inputWrapper) inputWrapper.style.display = 'flex';
            } else {
              await updateSavedAmount(cart, savedEl, wrapper, code, { force: true });
            }
          } catch (e) {
            console.error('Error checking discount:', e);
            try { localStorage.removeItem('applied_coupon_code'); } catch (ee) { }
            if (wrapper) wrapper.style.display = 'none';
            if (inputWrapper) inputWrapper.style.display = 'flex';
          } finally {
            _showAppliedCouponUIRunning = false;
          }
        })();

        return;
      }

      try {
        const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!cartRes || !cartRes.ok) {
          _showAppliedCouponUIRunning = false;
          return;
        }
        const cartCheck = await cartRes.json();

        let discountPresent = false;
        if (code) {
          if (Array.isArray(cartCheck.discount_codes) && cartCheck.discount_codes.some(dc => ((dc.code || String(dc) || '')).toUpperCase() === code.toUpperCase() && dc.applicable !== false)) {
            discountPresent = true;
          }
          if (Array.isArray(cartCheck.cart_level_discount_applications) && cartCheck.cart_level_discount_applications.some(a => (a.title || a.code || a.discount_code || '').toString().toUpperCase() === code.toUpperCase())) {
            discountPresent = true;
          }
        }

        if (!discountPresent) {
          try { localStorage.removeItem('applied_coupon_code'); } catch (e) { }
          _showAppliedCouponUIRunning = false;
          return;
        }

        if (inputWrapper) inputWrapper.style.display = 'none';
      } catch (e) {
        console.error('Cart check error:', e);
        try { localStorage.removeItem('applied_coupon_code'); } catch (e) { }
        _showAppliedCouponUIRunning = false;
        return;
      }

      try {
        const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.ok ? r.json() : null);
        await updateSavedAmount(cart, savedEl, wrapper, code, { force: false });
      } catch (e) {
        console.error('Update saved amount error:', e);
        savedEl.textContent = '';
      }

      wrapper.style.display = 'flex';
    } finally {
      _showAppliedCouponUIRunning = false;
    }
  }

  async function updateSavedAmount(cart, savedEl, wrapper, code, opts = {}) {
    try {
      const computeSaved = (c) => {
        if (!c) return 0;
        if (typeof c.total_discount !== 'undefined' && Number(c.total_discount) > 0) return Number(c.total_discount);
        if (typeof c.original_total_price !== 'undefined' && typeof c.total_price !== 'undefined') return Number(c.original_total_price) - Number(c.total_price);
        if (typeof c.items_subtotal_price !== 'undefined' && typeof c.total_price !== 'undefined') return Number(c.items_subtotal_price) - Number(c.total_price);
        return 0;
      };

      let savedCents = computeSaved(cart);

      let discountPresent = false;
      try {
        if (code) {
          if (Array.isArray(cart?.discount_codes) && cart.discount_codes.some(dc => ((dc.code || String(dc) || '')).toUpperCase() === code.toUpperCase() && dc.applicable !== false)) {
            discountPresent = true;
          }
          if (Array.isArray(cart?.cart_level_discount_applications) && cart.cart_level_discount_applications.some(a => (a.title || a.code || a.discount_code || '').toString().toUpperCase() === code.toUpperCase())) {
            discountPresent = true;
          }
        }
      } catch (e) { }

      if (savedCents === 0 && discountPresent) {
        for (let i = 0; i < 3; i++) {
          await new Promise(r => setTimeout(r, 300));
          try {
            const res = await fetch('/cart.js', { credentials: 'same-origin' });
            if (!res || !res.ok) continue;
            const latest = await res.json();
            const s = computeSaved(latest);
            if (s && s > 0) {
              savedCents = s;
              cart = latest;
              break;
            }
          } catch (e) { }
        }
      }

      let formatted = '';
      try {
        const cartCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || (window.theme && window.theme.currency) || (cart && cart.currency) || 'USD';
        formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: cartCurrency }).format((savedCents || 0) / 100);
      } catch (e) {
        formatted = (savedCents ? (savedCents / 100).toFixed(2) : '0.00');
      }

      try {
        const prevCode = wrapper.dataset.appliedCode || '';
        const prevSaved = wrapper.dataset.savedCents || '';
        const currSaved = String(savedCents || 0);
        const forceWrite = Boolean(opts && opts.force);
        if (forceWrite || prevCode !== (code || '') || prevSaved !== currSaved) {
          savedEl.textContent = `Saved ${formatted}`;
          savedEl.className = 'cart-applied-coupon__saved';
          wrapper.dataset.appliedCode = (code || '');
          wrapper.dataset.savedCents = currSaved;

          try {
            const popupSaved = document.querySelector('#cart-offers-popup #applied-coupon-saved') || document.querySelector('#cart-offers-popup .cart-applied-coupon__saved');
            if (popupSaved) popupSaved.textContent = `Saved ${formatted}`;
          } catch (e) { }
        }
      } catch (e) {
        savedEl.textContent = `Saved ${formatted}`;
        savedEl.className = 'cart-applied-coupon__saved';
      }
    } catch (e) {
      console.error('Update saved amount error:', e);
      savedEl.textContent = '';
    }
  }

  document.addEventListener('input', (function () {
    let debounceTimer;

    return function (e) {
      const input = e.target;

      if (!input.classList.contains('cart-offers-popup__coupon-input')) return;

      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(() => {
        if (!input.value.trim()) {
          const greenTick = document.querySelector('.cart-offers-popup__coupon-success');
          if (greenTick) {
            greenTick.style.display = 'none';
          }
        }
      }, 200);
    };
  })());

  function hideAppliedCouponUI() {
    const wrapper = document.getElementById('cart-applied-coupon');
    const inputWrapper = document.querySelector('.cart-coupon-input-wrapper');

    if (wrapper) wrapper.style.display = 'none';
    if (inputWrapper) inputWrapper.style.display = 'flex';

    const popupWrapper = document.querySelector('#cart-offers-popup .cart-applied-coupon');
    const popupInputWrapper = document.querySelector('#cart-offers-popup .cart-coupon-input-wrapper');

    if (popupWrapper) popupWrapper.style.display = 'none';
    if (popupInputWrapper) popupInputWrapper.style.display = 'flex';

    const mainInput = document.getElementById('cart-coupon-input');
    const popupInput = document.getElementById('cart-offers-coupon-input');
    if (mainInput) mainInput.value = '';
    if (popupInput) popupInput.value = '';
  }

  function removeAppliedDiscount() {
    const popupAppliedCoupon = document.querySelector('#cart-offers-popup .cart-applied-coupon');
    const popupInputWrapper = document.querySelector('#cart-offers-popup .cart-coupon-input-wrapper');

    if (popupAppliedCoupon) popupAppliedCoupon.style.display = 'none';
    if (popupInputWrapper) popupInputWrapper.style.display = 'flex';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: '' })
    })
      .then(() => {
        localStorage.removeItem('applied_coupon_code');
        hideAppliedCouponUI();

        return fetch('/cart?section_id=quick-cart');
      })
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newContainer = doc.querySelector('.quick-cart__container');
        const currentContainer = document.querySelector('.quick-cart__container');

        if (newContainer && currentContainer) {
          currentContainer.innerHTML = newContainer.innerHTML;
        }

        document.body.classList.add('js-drawer-open');

        const quickCart = document.querySelector('.quick-cart');
        const miniCart = document.querySelector('#t4s-mini_cart');

        quickCart?.classList.add('is-open', 'active');
        miniCart?.setAttribute('aria-hidden', 'false');

        const countEl = doc.querySelector('.quick-cart__heading sup');
        if (countEl) {
          document.querySelectorAll('[data-js-cart-count]').forEach(el => {
            el.textContent = countEl.textContent;
          });
        }

        const quickAtc = document.querySelector('quick-atc');
        if (quickAtc?.freeShipStatus) {
          quickAtc.freeShipStatus('.quick-cart .free-shipping-bar');
        } else if (typeof freeShipStatus === 'function') {
          freeShipStatus('.quick-cart .free-shipping-bar');
        }

        setTimeout(() => {
          typeof destroySwiper === 'function' && destroySwiper();
          typeof initSlider === 'function' && initSlider();
        }, 300);

        setTimeout(() => {
          safeInitializeCartOffers();
        }, 100);

        setTimeout(() => {
          const popupApplied = document.querySelector('#cart-offers-popup .cart-applied-coupon');
          const popupInput = document.querySelector('#cart-offers-popup .cart-coupon-input-wrapper');

          if (popupApplied) popupApplied.style.display = 'none';
          if (popupInput) popupInput.style.display = 'flex';
        }, 150);

        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(err => console.error('Remove discount error:', err));
  }

  function setupRemoveCouponHandlerOnce() {
    const btn = document.getElementById('remove-applied-coupon');
    const removeBtn = document.querySelector('.cart-offers-popup__body #remove-applied-coupon');

    // if (!btn || btn.dataset.bound) return;

    btn.dataset.bound = 'true';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      removeAppliedDiscount();
    });

    if (removeBtn && !removeBtn.dataset.bound) {
      removeBtn.dataset.bound = 'true';
      removeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        removeAppliedDiscount();
      });
    }
  }

  // function applyCouponCode(code, inputElement, applyButton) {
  //   if (!code || !code.trim()) {
  //     console.warn('No coupon code provided');
  //     return;
  //   }

  //   const discountCode = code.trim().toUpperCase();
  //   console.log('Applying coupon code:', discountCode);

  //   const wrapper =
  //     inputElement.closest('.cart-coupon-input-wrapper') ||
  //     inputElement.closest('.cart-offers-popup__coupon-input-wrapper');

  //   if (!wrapper) {
  //     console.error('Could not find wrapper element');
  //     return;
  //   }

  //   const loader =
  //     wrapper.querySelector('.cart-coupon-loader') ||
  //     wrapper.querySelector('.cart-offers-popup__coupon-loader');

  //   const successMsg =
  //     wrapper.querySelector('.cart-coupon-success') ||
  //     wrapper.querySelector('.cart-offers-popup__coupon-success');

  //   const input = inputElement;

  //   applyButton && (applyButton.style.display = 'none');
  //   loader && (loader.style.display = 'flex');
  //   successMsg && (successMsg.style.display = 'none');
  //   input.disabled = true;

  //   fetch(`/discount/${discountCode}`, {
  //     method: 'GET',
  //     headers: { 'X-Requested-With': 'XMLHttpRequest' }
  //   })
  //     .then(response => {
  //       console.log('Discount response:', response.status);
  //       loader && (loader.style.display = 'none');
  //       input.disabled = false;

  //       if (!response.ok) {
  //         throw new Error('Invalid coupon');
  //       }

  //       localStorage.setItem('applied_coupon_code', discountCode);
  //       showAppliedCouponUI(discountCode);
  //       successMsg && (successMsg.style.display = 'flex');

  //       const discountInput = document.querySelector('[data-cart-discount]');
  //       if (discountInput) discountInput.value = discountCode;

  //       return fetch('/cart?section_id=quick-cart');
  //     })
  //     .then(res => res.text())
  //     .then(html => {
  //       if (!html) return;

  //       const doc = new DOMParser().parseFromString(html, 'text/html');

  //       const newContainer = doc.querySelector('.quick-cart__container');
  //       const currentContainer = document.querySelector('.quick-cart__container');

  //       if (newContainer && currentContainer) {
  //         currentContainer.innerHTML = newContainer.innerHTML;
  //       }

  //       document.body.classList.add('js-drawer-open');
  //       document.querySelector('.quick-cart')?.classList.add('is-open');

  //       const countEl = doc.querySelector('.quick-cart__heading sup');
  //       if (countEl) {
  //         document.querySelectorAll('[data-js-cart-count]').forEach(el => {
  //           el.textContent = countEl.textContent;
  //         });
  //       }

  //       const quickAtc = document.querySelector('quick-atc');
  //       if (quickAtc?.freeShipStatus) {
  //         quickAtc.freeShipStatus('.quick-cart .free-shipping-bar');
  //       } else if (typeof freeShipStatus === 'function') {
  //         freeShipStatus('.quick-cart .free-shipping-bar');
  //       }

  //       setTimeout(() => {
  //         typeof destroySwiper === 'function' && destroySwiper();
  //         typeof initSlider === 'function' && initSlider();
  //       }, 400);

  //       document.dispatchEvent(new CustomEvent('cart:update', {
  //         detail: { discount: discountCode }
  //       }));

  //       setTimeout(() => {
  //         if (applyButton && input.value.trim()) {
  //           applyButton.style.display = 'block';
  //         }
  //       }, 4000);
  //     })
  //     .catch(err => {
  //       console.error('Discount apply failed:', err);

  //       loader && (loader.style.display = 'none');
  //       input.disabled = false;

  //       if (applyButton && input.value.trim()) {
  //         applyButton.style.display = 'block';
  //       }

  //       alert(
  //         err.message === 'Invalid coupon'
  //           ? 'This coupon is no longer valid.'
  //           : 'Something went wrong. Please try again.'
  //       );
  //     });
  // }
  function applyCouponCode(code, inputElement, applyButton) {
    if (!code || !code.trim()) {
      console.warn('No coupon code provided');
      return;
    }

    const discountCode = code.trim().toUpperCase();

    const wrapper =
      inputElement.closest('.cart-coupon-input-wrapper') ||
      inputElement.closest('.cart-offers-popup__coupon-input-wrapper');

    if (!wrapper) {
      console.error('Could not find wrapper element');
      return;
    }

    const loader = wrapper.querySelector('.cart-coupon-loader');
    const successMsg = wrapper.querySelector('.cart-coupon-success');
    const errorIcon = wrapper.querySelector('.cart-coupon-error');

    // error text banner lives OUTSIDE the wrapper, right after it
    const errorBanner =
      wrapper.parentElement.querySelector('#cart-coupon-error-msg') ||
      wrapper.parentElement.querySelector('.cart-offers-popup__coupon-error-msg');

    const input = inputElement;

    applyButton && (applyButton.style.display = 'none');
    loader && (loader.style.display = 'flex');
    successMsg && (successMsg.style.display = 'none');
    errorIcon && (errorIcon.style.display = 'none');
    errorBanner && (errorBanner.style.display = 'none');
    wrapper.classList.remove('has-error');
    input.disabled = true;

    fetch(`/discount/${discountCode}`, {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => {
        if (!response.ok) throw new Error('Invalid coupon');
        return fetch('/cart.js'); // real validation source
      })
      .then(res => res.json())
      .then(cart => {
        const applied = cart.discount_codes?.find(
          dc => dc.code.toUpperCase() === discountCode
        );

        if (!applied || !applied.applicable) {
          throw new Error('Invalid coupon');
        }

        loader && (loader.style.display = 'none');
        input.disabled = false;

        localStorage.setItem('applied_coupon_code', discountCode);
        showAppliedCouponUI(discountCode);
        successMsg && (successMsg.style.display = 'flex');

        const discountInput = document.querySelector('[data-cart-discount]');
        if (discountInput) discountInput.value = discountCode;

        return fetch('/cart?section_id=quick-cart');
      })
      .then(res => res?.text())
      .then(html => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newContainer = doc.querySelector('.quick-cart__container');
        const currentContainer = document.querySelector('.quick-cart__container');
        if (newContainer && currentContainer) {
          currentContainer.innerHTML = newContainer.innerHTML;
        }

        document.body.classList.add('js-drawer-open');
        document.querySelector('.quick-cart')?.classList.add('is-open');

        const countEl = doc.querySelector('.quick-cart__heading sup');
        if (countEl) {
          document.querySelectorAll('[data-js-cart-count]').forEach(el => {
            el.textContent = countEl.textContent;
          });
        }

        const quickAtc = document.querySelector('quick-atc');
        if (quickAtc?.freeShipStatus) {
          quickAtc.freeShipStatus('.quick-cart .free-shipping-bar');
        } else if (typeof freeShipStatus === 'function') {
          freeShipStatus('.quick-cart .free-shipping-bar');
        }

        setTimeout(() => {
          typeof destroySwiper === 'function' && destroySwiper();
          typeof initSlider === 'function' && initSlider();
        }, 400);

        document.dispatchEvent(new CustomEvent('cart:update', {
          detail: { discount: discountCode }
        }));

        setTimeout(() => {
          if (applyButton && input.value.trim()) {
            applyButton.style.display = 'block';
          }
        }, 4000);
      })
      .catch(err => {
        console.error('Discount apply failed:', err);

        loader && (loader.style.display = 'none');
        input.disabled = false;

        // clear any bad state
        localStorage.removeItem('applied_coupon_code');
        const discountInput = document.querySelector('[data-cart-discount]');
        if (discountInput) discountInput.value = '';
        fetch(`/discount/`).catch(() => { }); // clear Shopify's discount cookie

        const mainInput = document.getElementById('cart-coupon-input');
        const popupInput = document.getElementById('cart-offers-coupon-input');
        if (mainInput) mainInput.value = '';
        if (popupInput) popupInput.value = '';

        const btn = document.getElementById('cart-coupon-apply-btn');
        const popupBtn = document.getElementById('cart-offers-popup-apply-btn');
        if (btn) btn.style.display = 'none';
        if (popupBtn) popupBtn.style.display = 'none';

        // inline error UI instead of alert()
        errorIcon && (errorIcon.style.display = 'flex');
        wrapper.classList.add('has-error');

        if (errorBanner) {
          errorBanner.textContent =
            err.message === 'Invalid coupon'
              ? 'Cart Ineligible For Offer.'
              : 'Something went wrong. Please try again.';
          errorBanner.style.display = 'block';
          fetch(`/discount/`).catch(() => { }); // clear Shopify's discount cookie
          setTimeout(() => {
            errorBanner.style.display = 'none';
            errorIcon && (errorIcon.style.display = 'none');
            wrapper.classList.remove('has-error');
          }, 4000);
        }
      });
  }
  function checkOfferEligibility() {
    const wrapper = document.querySelector('[data-cart-wrapper]');
    const count = parseInt(wrapper?.dataset.ccount || 0);

    document.querySelectorAll('.cart-offers-popup__offer-item').forEach((item) => {
      const min = parseInt(item.dataset.minQty || 0);

      if (count >= min) {
        item.classList.add('offer-available');
        item.classList.remove('offer-unavailable');
      } else {
        item.classList.add('offer-unavailable');
        item.classList.remove('offer-available');
      }
    });
  }

  function toggleCartOffersSections(count) {
    document.querySelectorAll('[data-cart-offers-section]').forEach((s) => {
      s.style.display = count > 0 ? '' : 'none';
    });
  }

  async function fetchCartData() {
    try {
      const r = await fetch('/cart.js');
      const c = await r.json();
      return c.item_count || 0;
    } catch {
      return 0;
    }
  }

  async function fetchQuickCartElement() {
    const getSectionUrl = () => {
      try {
        if (window.theme && theme.routes && theme.routes.cart && theme.routes.cart.base) {
          return theme.routes.cart.base + '?section_id=quick-cart';
        }
      } catch (e) { }
      return '/cart?section_id=quick-cart';
    };

    try {
      const res = await fetch(getSectionUrl(), { credentials: 'same-origin' });
      if (!res || !res.ok) return null;
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const el = tmp.querySelector('.quick-cart');
      return el || null;
    } catch (e) {
      return null;
    }
  }

  async function refreshQuickCartFromServer() {
    try {
      const newEl = await fetchQuickCartElement();
      if (newEl) {
        const existing = document.querySelector('.quick-cart');
        if (existing) {
          existing.innerHTML = newEl.innerHTML;
          try { dedupeOffersElements(); } catch (e) { /* ignore */ }
        }
      }

      try {
        const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      } catch (e) {
        // ignore
      }

      document.dispatchEvent(new CustomEvent('quick-cart:updated'));
      document.dispatchEvent(new CustomEvent('cart-drawer:html-updated'));

      if (typeof updateCartDrawer === 'function') {
        try { updateCartDrawer(); } catch (e) { /* ignore */ }
      }

      try { await safeInitializeCartOffers(); } catch (e) { /* ignore */ }
    } catch (e) {
      // ignore
    }
  }
  function initializeCartOffersAfterUpdate(itemCount) {
    return new Promise(async (resolve) => {
      const count = itemCount ?? (await fetchCartData());
      toggleCartOffersSections(count);
      setupPopupHandlersOnce();
      try { dedupeOffersElements(); } catch (e) { /* ignore */ }
      setupCouponSyncOnce();
      setupApplyHandlersOnce();
      setupRemoveCouponHandlerOnce();
      checkOfferEligibility();

      const savedCoupon = localStorage.getItem('applied_coupon_code');
      if (savedCoupon) {
        showAppliedCouponUI(savedCoupon, { force: true });
      } else {
        try {
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(r => r.json())
            .then(cart => {
              if (!cart) return;
              const applicableCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes.filter(dc => dc && dc.applicable !== false) : [];
              if (applicableCodes.length) {
                const code = (applicableCodes[0].code || applicableCodes[0] || '').toString().toUpperCase();
                if (code) {
                  try { localStorage.setItem('applied_coupon_code', code); } catch (e) { }
                  showAppliedCouponUI(code);
                }
                return;
              }

              if (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length) {
                const app = cart.cart_level_discount_applications[0];
                const title = (app && (app.title || app.code || app.discount_code || ''))?.toString() || '';
                const code = title.toUpperCase();
                if (code) {
                  try { localStorage.setItem('applied_coupon_code', code); } catch (e) { }
                  showAppliedCouponUI(code);
                }
              }
            })
            .catch(() => { });
        } catch (e) {
          /* ignore */
        }
      }

      resolve();
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-remove-coupon]');
    if (!btn) return;

    e.preventDefault();
    removeAppliedDiscount();
  });

  ['cart:update', 'cart:updated', 'cart-drawer:html-updated'].forEach((e) => {
    document.addEventListener(e, (ev) => {
      safeInitializeCartOffers(ev.detail?.item_count);
    });
  });

  const cartDrawer = document.querySelector('#t4s-mini_cart');

  if (cartDrawer) {
    const observer = new MutationObserver((mutations) => {
      let shouldInit = false;



      setTimeout(() => {
        safeInitializeCartOffers();
      }, 150);
    });

    observer.observe(cartDrawer, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['aria-hidden']
    });
  }

  // ⭐ Additional observer for .quick-cart__container changes
  const quickCartContainer = document.querySelector('.quick-cart__container');
  if (quickCartContainer) {
    const containerObserver = new MutationObserver((mutations) => {
      let hasContentChange = false;



      if (hasContentChange) {
        setTimeout(() => {
          safeInitializeCartOffers();
        }, 150);
      }
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCartOffers();
      try { safeInitializeCartOffers(); } catch (e) { /* ignore */ }
    });
  } else {
    initCartOffers();
    try { safeInitializeCartOffers(); } catch (e) { /* ignore */ }
  }
})();